import { limitLines } from 'src/styles'
import styled from 'styled-components'

type PostHTMLProps = {
  $limitChars?: boolean
}

export const PostHTML = styled.div<PostHTMLProps>`
  ${({ $limitChars }) => ($limitChars ? limitLines(3) : 'word-wrap: break-word;')};

  * {
    font-weight: var(--font-weight-light);
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  > p,
  > ul,
  > ol {
    margin-bottom: var(--spacer-3) !important;
  }

  > ul,
  > ol {
    ul,
    ol {
      margin-bottom: 0 !important;
      padding-left: var(--spacer-4) !important;
    }
  }

  ul,
  ol {
    padding-left: var(--spacer-5) !important;
  }

  ul li {
    list-style: disc !important;
  }

  ol li {
    list-style: decimal !important;
  }

  strong,
  b {
    font-weight: var(--font-weight-bold) !important;
  }

  em,
  i {
    font-style: italic !important;
  }

  u {
    text-decoration: underline !important;
  }

  a {
    color: var(--blue) !important;
    text-decoration: none !important;

    &:hover {
      text-decoration: underline !important;
    }
  }
`

PostHTML.displayName = 'PostHTML'
